import cx from 'classnames';
import * as React from 'react';

import { ICONS } from 'constants/IconConstants';

import './styles/Icon.scss';

export type IconColor =
  | 'currentColor'
  | 'lava'
  | 'flame'
  | 'tuscan'
  | 'sunrise'
  | 'cactus'
  | 'jungle'
  | 'shamrock'
  | 'caribbean'
  | 'midnight'
  | 'twilight'
  | 'brand'
  | 'iris'
  | 'violet'
  | 'black'
  | 'pitch'
  | 'thunder'
  | 'eclipse'
  | 'koala'
  | 'wolf'
  | 'polar-bear'
  | 'snow'
  | 'white'
  | 'google-sheets'
  | 'microsoft-excel';
export type IconName = keyof typeof ICONS;
export type IconSize = 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'small' | 'inherit';

type Props = {
  className?: string;
  color?: IconColor;
  name: IconName;
  size?: IconSize;
};

export default function Icon({ className, color = 'currentColor', name, size = 'medium' }: Props) {
  const sizePx = 32;

  return (
    <svg
      width={sizePx}
      height={sizePx}
      viewBox={`0 0 ${sizePx} ${sizePx}`}
      className={cx('Icon', color && `Icon--${color}`, size && `Icon--${size}`, className)}>
      <path d={ICONS[name]} />
    </svg>
  );
}
